import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { List, ListDivider } from 'react-toolbox/lib/list'
import { mapProps, branch, renderNothing, compose } from 'recompose'
import CSSModules from 'helpers/CSSModulesUtil'
import * as R from 'ramda'
import T from 'i18n-react'

import hideOnAnyRoles from 'containers/Role/Hide/AllGlobalRoles'
import Divider from 'components/fulcrum/divider/Divider'
import CommentBox from 'components/custom/Comments/CommentBox'
import CommentItem from 'components/custom/Comments/CommentItem'
import progressBarHoc from 'containers/Async/AsyncProgressBar'
import Title from './Title'

import { GLOBAL_ROLES } from 'containers/Role/constants'
import {
  FETCH_COMMENTS,
} from './constants'
import {
  postComment,
} from './actions'
import {
  commentsSelector,
} from './selectors'
import {
  projectIdSelector,
} from 'containers/Project/View/selectors'
import {
  currentRevisionSelector,
} from 'containers/Project/GreenlightReport/selectors'

import styles from './styles.scss'

const mapStateToProps = state => {
  return {
    projectId: projectIdSelector(state),
    comments: commentsSelector(state),
    revision: currentRevisionSelector(state)
  }
}

const mapDispatchToProps = dispatch => {
  return {
    postComment: (projectId, revision, comment) => dispatch(postComment(projectId, revision, comment)),
  }
}

const ProgressBar = progressBarHoc([FETCH_COMMENTS])

class GreenlightComments extends Component {
  static propTypes = {
    comments: PropTypes.array.isRequired,
    postComment: PropTypes.func.isRequired
  }

  createComments(){
    return this.props.comments.reduce((componentList, value) => {
      const {
        username,
        name,
        comment,
        id,
        date,
        image
      } = value

      return componentList.concat([
        <CommentItem
          key={id}
          image={image}
          name={name}
          comment={comment}
          date={date}
        />,
        <ListDivider key={'divider_' + id}/>
      ])
    }, [])
  }

  createComment = () => {
    return (comment) => {
      const {
        projectId,
        revision,
        postComment,
      } = this.props

      postComment(projectId, revision, comment)
    }
  }

  render() {
    return (
      <div>
        <Divider/>
        <Title>
          { T.translate('containers.project.greenlightCommentSection.index.header') }
        </Title>
        <ProgressBar/>
        <List>
          { this.createComments() }
        </List>
        <CommentBox onSubmit={ this.createComment() }/>
      </div>
    )
  }
}

const withoutRoles = compose(
  mapProps(
    (props) => ({
      ...props,
      roles: [
        GLOBAL_ROLES.CLIENT_ACCESS,
      ]
    })
  ),
  hideOnAnyRoles,
)

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const enhance = compose(
  withoutRoles,
  withConnect,
  branch(
    ({ revision }) => R.isNil(revision),
    renderNothing
  )
)

export default enhance(GreenlightComments)
